import React, { Component } from 'react';
import './footer.css';
import { connect } from 'react-redux';
import MyPATLink from '../../common/MyPATLink';
import { UserData } from '../../login/types/UserData';
import { Redirect } from 'react-router-dom';
import { components as headerComponents } from '../../header';
import Header from '../../header/components/Header';
//@ts-ignore
interface LoginProps extends WithStyles<typeof styles> {
  userData: UserData,
  setSelectedRole: Function,
  history: any,
}

interface LoginState {
}

class disclaimer extends Component<LoginProps, LoginState> {
  constructor(props: LoginProps, state: LoginState) {
      super(props);
  }
  state = {};

  redirection() {
    if (this.props.userData.isAuthenticated) {
      <Redirect to='/mylibrary' />
    } else {
      <Redirect to='/login' />
    }
  }
  render() {
    return (
      <>{
        this.props.userData.isAuthenticated && <Header/>
      }
      <div className={`containerMain ${this.props.userData.isAuthenticated ? 'newMain' : ''}`}>
         <div className="headerMain">
         <span>
         <MyPATLink align="right" variant="body2" onClick={this.redirection} to={''}><img src="/assets/svg/authors-new-logo.svg" alt="" /></MyPATLink>
          </span>
          <span><MyPATLink className="linkButton" align="right" variant="body2" onClick={this.redirection} to={''}>Login</MyPATLink></span>
        </div>
        <div className="container">
          <h2>Warranty Disclaimer and Limitation of Liability</h2>
          <p>
            The information/material provided on the website is provided on
            an “As is” basis. EDFORA INFOTECH PRIVATE LIMITED. (hereinafter
            referred to as “EDFORA) expressly disclaims to the maximum limit
            permissible by law, all warranties, express or implied,
            including, but not limiting to implied warranties of
            merchantability, fitness for a particular purpose and
            non-infringement. Edfora disclaims all responsibility for any
            loss, injury, liability or damage of any kind resulting from and
            arising out of, or in any way related to:
            <ol>
              <li>
                Any errors in or omissions from the website and its content,
                including but not limited to technical inaccuracies and
                typographical errors;
              </li>
              <li>
                Any third party websites or content therein directly or
                indirectly accessed through links in the site, including but
                not limited to any errors in or omissions there from;
              </li>
              <li>
                The unavailability of this site or any portion thereof;
              </li>
              <li>
                Your use of any equipment or software in connection with the
                site; and/or
              </li>
              <li>Your use of the site.</li>
            </ol><br/>
            <b>Limitation of Liability</b>
            Under no circumstances shall Edfora be liable to you for:<br/>
            <ol>
              <li>
                Loss, injury, claim, liability or damages of any kind
                resulting from the use of or the inability to use the
                materials in the website, even if Edfora had been advised of
                the possibility of such damages and regardless of the form
                of action, whether in contract, tort or otherwise;
              </li>
              <li>
                Special, direct, incidental, punitive, exemplary, general or
                consequential damages of any kind whatsoever (including
                without limitation, attorney's fees) in any way due,
                resulting from or arising in connection with the use of or
                the inability to use the website or its content / material;
                and
              </li>
              <li>
                Claim attributable to errors, omission or inaccuracies in or
                destructive properties of any information.
              </li>
              <li>
                Our liability would be limited to the value of service
                availed by you.
              </li>
            </ol>
            <br />
            <b>AS a consequence of:</b>
            Use or performance of our website, with the delay or inability
            to use our website or related services, the provision of or
            failure to provide services, or for any information, software,
            products and services obtained through our website, or otherwise
            arising out of the use of our website, whether based on
            contract, negligence, strict liability or otherwise, even if we
            or any of our suppliers has been advised of the possibility of
            damages.
            <br /><br/>
            <b>No Liability</b>
            <ol>
              <li>
                EDFORA makes reasonable efforts to ensure that the
                information provided on the website is accurate but does not
                guarantee or warrant its accuracy, adequacy, correctness,
                validity, completeness or suitability for any purpose.
              </li>
              <li>
                EDFORA accepts no responsibility with respect to the
                information on the site.
              </li>
              <li>
                Use of this site by implication means that you have gone
                through and agreed to abide by the terms of use, privacy
                policy, copyright notice and the disclaimers of this site.
              </li>
              <li>
                EDFORA does not represent that the information downloaded
                from this website is completely error-free and accurate or
                the servers that make EDFORA websites available are free of
                viruses or harmful components. Though due care has been
                taken to make the database completely reliable and
                error-free, EDFORA claims exemption from any liability
                arising out of any such error in the database.
              </li>
              <li>
                EDFORA provides documents that you are likely to use in
                various tests or exams and for other education or career
                related purposes.
              </li>
              <li>
                All contents in our database are provided without any
                warranty, express or implied, as to their accuracy and
                completeness. You are advised to use the contents with due
                care and with due diligence to verify the accuracy of
                content.
              </li>
              <li>
                EDFORA does not offer any warranty with respect to the
                usefulness of content for any particular purpose.
              </li>
            </ol><br/>
            <b>Offline Help</b>
            Any form of work done or services or information provided by
            EDFORA or any person or persons associated with EDFORA vide
            their Offline Help is provided as a paid support service without
            any liability whatsoever. Work done, services rendered or
            information provided, are subject to your own verification and
            professional expertise opinions/advice. Our work and services
            are not to be deemed as final with respect to accuracy for
            suitability for any particular purpose.
            <br /><br/>
            <b>We make no warranty that:</b>
            <ol>
              <li>The service will meet your requirements</li>
              <li>
                The service will be uninterrupted, timely, secure, or
                error-free
              </li>
              <li>
                The solutions that may be obtained from the use of the
                service will be accurate or reliable
              </li>
              <li>
                The quality of any services, information, or other material
                obtained by you through the service will meet your
                expectations
              </li>
            </ol><br/>
            Any material downloaded and used for educational or other
            purposes shall be at your own risk and no service offered by our
            website is intended to give any kind of warranty about the
            content or services.
            <br />
            <br />
            EDFORA disclaims all responsibility in case where any
            information/page is downloaded from the website and after
            downloading complete/partial, text/information is
            altered/removed/obscured contained therein due to any reason
            whatsoever.
            <br />
            <br />
            EDFORA and/or its respective suppliers make no representations
            about the suitability, reliability, availability, timeliness of
            the products and services contained/displayed on the website for
            any purpose. All products, services are provided "as is" without
            warranty of any kind. EDFORA and/or its third party associates
            hereby disclaim all warranties and conditions with regard to
            this information, products, services including all implied
            warranties and conditions of merchantability, fitness for a
            particular purpose, title and non-infringement.
          </p><br/>
        </div>
      </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData,
});


export default connect(
  mapStateToProps
  // @ts-ignore
) (disclaimer);